// UserEditModal.js
import '../../Assets/Styles/register.css';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { Dropdown } from 'primereact/dropdown';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tooltip } from 'primereact/tooltip';
import { Skeleton } from 'primereact/skeleton';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import * as AppActions from '../../Store/Actions/App';
import * as UserActions from '../../Store/Actions/User';

import {
  validarEmail,
  validarTelefone,
  validarCPF,
  maskPhone,
  disableBodyScroll,
  enableBodyScroll,
  validarDataNascimentoMinima
} from '../../Components/Utils';

// abaixo dos imports/utilidades
const STATUS_OPTIONS = [
  { label: 'Ativo', value: 1 },
  { label: 'Inativo', value: 0 },
  { label: 'Bloqueado', value: 2 }
];

const UserEditModal = (props) => {
  const {
    dialog,
    setDialog,

    // Loaders já existentes (iguais aos usados na Create):
    retrieveDropdownPersonGroups,
    retrieveDropdownUserProfiles,
    retrieveDropdownAgencies,
    retrieveRightsByProfile,

    // Novas/ajustadas actions:
    retrieveUserForEdit,
    updateUser,
    deleteUser,

    setAlert, setAlertTitle, setAlertBody,
    selectCompany,
    isMasterUser,
    userRights,
    onReloadDataList,

    selectedUser,
    userId
  } = props;

  const isOpen = dialog.target === 'userEditModal' && dialog.status;

  // console.log('[selectedUser]--------->]'+JSON.stringify(selectedUser, null, 2));
  // console.log('[userId]--------->]'+JSON.stringify(userId, null, 2));
  
  const CompanyPersonName = selectedUser?.CompanyPerson?.completeName || '';
  
  const toast = React.useRef(null);

  // loaders
  const [saving, setSaving] = React.useState(false);
  const [loadingRights, setLoadingRights] = React.useState(false);
  const [loadingForm, setLoadingForm] = React.useState(false);

  // FORM: Dados da Pessoa
  const [nomeCompleto, setNomeCompleto] = React.useState('');
  const [cpf, setCpf] = React.useState('');
  const [nascimento, setNascimento] = React.useState(''); // dd/mm/aaaa
  const [celular, setCelular] = React.useState('');
  const [pessoaGrupo, setPessoaGrupo] = React.useState(null);
  const [isMaster, setIsMaster] = React.useState(false);

  // Seleção de Agência (quando master)
  const [selectedCompany, setSelectedCompany] = React.useState(null);

  // Senha opcional na edição
  const [wantPasswordNow, setWantPasswordNow] = React.useState(false);
  const [senha, setSenha] = React.useState('');
  const [senha2, setSenha2] = React.useState('');

  // FORM: Dados do Usuário
  const [usuarioPerfil, setUsuarioPerfil] = React.useState(null);
  const [email, setEmail] = React.useState('');
  const [email2, setEmail2] = React.useState('');
  const [editEmail, setEditEmail] = React.useState(false);

  const [userStatus, setUserStatus] = React.useState(1); // 0 Inativo | 1 Ativo | 2 Bloqueado

  // Direitos
  const [direitosDoPerfil, setDireitosDoPerfil] = React.useState([]);
  const [rightsCustom, setRightsCustom] = React.useState({
    manageAgencyUsers: false,
    seeOwnReservationsOnly: false
  });

  // Dropdown options/loaders (mesmo padrão da Create)
  const [pessoaGruposOptions, setPessoaGruposOptions] = React.useState([]);
  const [usuarioPerfisOptions, setUsuarioPerfisOptions] = React.useState([]);
  const [agenciasOptions, setAgenciasOptions] = React.useState([]);

  const [loadingPessoaGrupos, setLoadingPessoaGrupos] = React.useState(false);
  const [loadingUsuarioPerfis, setLoadingUsuarioPerfis] = React.useState(false);
  const [loadingAgencias, setLoadingAgencias] = React.useState(false);

  const [initialSnapshot, setInitialSnapshot] = React.useState(null);
  const [isDirty, setIsDirty] = React.useState(false);

  console.log('[isDirty]--------->]'+JSON.stringify(isDirty, null, 2));

 const buildSnapshot = (src = null, baseCompanyId = null) => {
    // src = objeto vindo do backend (user) OU null para usar os states atuais
    if (src) {
      const p = src.person || {};
      return {
        // se selectCompany=false, mantemos o companyId do snapshot inicial para não marcar dirty
        companyId: selectCompany ? (selectedCompany ?? null) : (baseCompanyId ?? null),        
        person: {
          fullName: p.fullName ?? '',
          cpf: (p.cpf ?? '').replace(/\D/g, ''),
          birthDate: p.birthDate ?? '',
          phone: (p.phone ?? '').replace(/\D/g, ''),
          group: p.group ?? null
        },
        user: {
          profile: src.profile ?? null,
          email: src.email ?? '',
          status: (typeof src.status === 'number') ? src.status :
                  (src.status != null ? Number(src.status) : 1)          
        },
        rights: {
          custom: {
            manageAgencyUsers: !!(src.rights && src.rights.custom && src.rights.custom.manageAgencyUsers),
            seeOwnReservationsOnly: !!(src.rights && src.rights.custom && src.rights.custom.seeOwnReservationsOnly)
          }
        },
        editPassword: false
      };
    }
    // snapshot a partir dos states atuais
    return {
      companyId: selectCompany ? (selectedCompany ?? null) : null,
      person: {
        fullName: nomeCompleto,
        cpf: (cpf || '').replace(/\D/g, ''),
        birthDate: nascimento,
        phone: (celular || '').replace(/\D/g, ''),
        group: pessoaGrupo
      },
      user: {
        profile: usuarioPerfil,
        email: editEmail ? email : (initialSnapshot?.user?.email ?? ''),
        status: userStatus
      },
      rights: {
        custom: {
          manageAgencyUsers: !!rightsCustom.manageAgencyUsers,
          seeOwnReservationsOnly: !!rightsCustom.seeOwnReservationsOnly
        }
      },
      // senha só conta como alteração se for solicitada e preenchida
      editPassword: !!wantPasswordNow
    };
  };

// Normaliza respostas/erros do endpoint de exclusão
const getDeleteUserFeedback = (resp, err) => {
  // 1) Respostas 200 OK com payload de controle
  if (resp && typeof resp === 'object') {
    // caminho feliz
    if (resp.success && resp.deleted) {
      return { type: 'success', title: 'Usuário excluído', body: 'O usuário foi removido com sucesso. Caso ele estivesse logado, a sessão foi encerrada e ele precisará fazer login novamente para acessar o sistema.' };
    }
    // não encontrado no escopo
    if (resp.notFound) {
      return { type: 'warn', title: 'Não encontrado', body: 'Nenhum usuário foi encontrado para o escopo informado. Ele pode já ter sido removido.' };
    }
    // erro conhecido por códigos de negócio
    if (resp.error) {
      switch (String(resp.errorCode || '')) {
        case '40301': // autoexclusão
          return { type: 'error', title: 'Ação não permitida', body: 'Você não pode excluir o próprio usuário.' };
        case '40302': // tentar excluir master
          return { type: 'error', title: 'Ação não permitida', body: 'Não é permitido excluir um usuário Master.' };
        default:
          // mensagem vinda do backend ou genérica
          return { type: 'error', title: 'Erro ao excluir', body: resp.errorMessage || 'Falha ao excluir usuário.' };
      }
    }
  }

  // 2) Exceções (HTTP != 200, rede, etc.)
  if (err) {
    const status = err?.response?.status;
    const data = err?.response?.data;
    // tenta mesma lógica por errorCode, se veio payload
    if (data && data.error) {
      switch (String(data.errorCode || '')) {
        case '40301':
          return { type: 'error', title: 'Ação não permitida', body: 'Você não pode excluir o próprio usuário.' };
        case '40302':
          return { type: 'error', title: 'Ação não permitida', body: 'Não é permitido excluir um usuário Master.' };
        default:
          return { type: 'error', title: 'Erro ao excluir', body: data.errorMessage || `Falha ao excluir usuário. (HTTP ${status || '—'})` };
      }
    }
    // fallback genérico
    return { type: 'error', title: 'Erro ao excluir', body: `Falha ao excluir usuário. ${err.message || ''}`.trim() };
  }

  // 3) fallback extremo
  return { type: 'error', title: 'Erro ao excluir', body: 'Falha ao excluir usuário.' };
};

  const resetAndClose = () => {
    // Reload parent list
    onReloadDataList?.();

    setSelectedCompany(null);
    setNomeCompleto('');
    setCpf('');
    setNascimento('');
    setCelular('');
    setPessoaGrupo(null);

    setUsuarioPerfil(null);
    setEmail('');
    setEmail2('');
    setWantPasswordNow(false);
    setSenha('');
    setSenha2('');

    setDireitosDoPerfil([]);
    setRightsCustom({ manageAgencyUsers: false, seeOwnReservationsOnly: false });

    setPessoaGruposOptions([]);
    setUsuarioPerfisOptions([]);
    setAgenciasOptions([]);

    setLoadingPessoaGrupos(false);
    setLoadingUsuarioPerfis(false);
    setLoadingAgencias(false);
    setLoadingRights(false);
    setSaving(false);
    setLoadingForm(false);

    setDialog('userEditModal', false);
  };

  // Carrega direitos quando muda o perfil (igual Create)
  React.useEffect(() => {
    const run = async () => {
      if (!usuarioPerfil) { setDireitosDoPerfil([]); return; }
      try {
        setLoadingRights(true);
        const resp = await retrieveRightsByProfile(
          { profileId: usuarioPerfil, selectCompany: !isMasterUser },
          {
            setRights: (arr) => setDireitosDoPerfil(Array.isArray(arr) ? arr : [])
          }
        );
        if (resp?.success && Array.isArray(resp?.data)) {
          setDireitosDoPerfil(resp.data);
        }
      } catch {
        setDireitosDoPerfil([]);
      } finally {
        setLoadingRights(false);
      }
    };
    run();
  }, [usuarioPerfil, isMasterUser, retrieveRightsByProfile]);

  // Ao abrir modal: carrega dropdowns e, depois, carrega dados do usuário para preencher
  React.useEffect(() => {
    if (!isOpen) { enableBodyScroll(); return; }
    disableBodyScroll();

    (async () => {
      try {
        setLoadingForm(true);

        // 2) Carregar dados do usuário
        if (!userId) {
          setAlert(true);
          setAlertTitle('Erro');
          setAlertBody('ID do usuário não informado para edição.');
          setLoadingForm(false);
          return;
        }        

        // 1) Dropdowns (exatamente como na Create)
        setLoadingPessoaGrupos(true);
        retrieveDropdownPersonGroups(
          {},
          {
            setRows: setPessoaGruposOptions,
            setLoadingData: setLoadingPessoaGrupos
          }
        );

        setLoadingUsuarioPerfis(true);
        retrieveDropdownUserProfiles(
          {},
          {
            setRows: setUsuarioPerfisOptions,
            setLoadingData: setLoadingUsuarioPerfis
          }
        );

        if (selectCompany) {
          setLoadingAgencias(true);
          retrieveDropdownAgencies(
            {},
            {
              setRows: setAgenciasOptions,
              setLoadingData: setLoadingAgencias
            }
          );
        }


        const resp = await retrieveUserForEdit(
          { userId },
          {
            // Padrão de handlers no seu projeto:
            setForm: (user) => {

              if (!user) return;

              // Mapeamento defensivo p/ manter compatibilidade
              const p = user.person || {};

              setSelectedCompany(user.companyId ?? null);
              setNomeCompleto(p.fullName ?? '');
              setCpf(p.cpf ?? '');
              setNascimento(p.birthDate ?? ''); // já formatado dd/mm/aaaa
              setCelular(p.phone ? maskPhone(p.phone) : '');

              setPessoaGrupo(p.group ?? null);

              setUsuarioPerfil(user.profile ?? null);

              setUserStatus(
                typeof user.status === 'number' ? user.status :
                user.status != null ? Number(user.status) : 1
              );

              setEmail(user.email ?? '');
              setEmail2(user.email ?? '');

              setIsMaster(user.master || false);

              // direitos (fromProfile + custom)
              const fromProfile = (user.rights && user.rights.fromProfile) || [];
              const custom = (user.rights && user.rights.custom) || {};
              setDireitosDoPerfil(fromProfile);
              setRightsCustom({
                manageAgencyUsers: !!custom.manageAgencyUsers,
                seeOwnReservationsOnly: !!custom.seeOwnReservationsOnly
              });

              // snapshot inicial a partir do objeto do backend (usa src.email corretamente)
              setInitialSnapshot(buildSnapshot(user));

              // começa sem “editar e-mail” ativo
              setEditEmail(false);
          

            },
            onError: (msg) => {
              setAlert(true);
              setAlertTitle('Erro ao carregar usuário');
              setAlertBody(msg || 'Não foi possível carregar os dados do usuário.');
            //  resetAndClose();
            }
          }
        );

        if (resp?.error) {
          setAlert(true);
          setAlertTitle('Erro ao carregar usuário');
          setAlertBody(resp?.errorMessage || 'Não foi possível carregar os dados.');
        }
      } catch (e) {
        setAlert(true);
        setAlertTitle('Erro');
        setAlertBody(e?.message || 'Falha ao carregar os dados do usuário.');
      } finally {
        setLoadingForm(false);
      }
    })();

    return () => enableBodyScroll();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  // Recalcula se houve alterações vs snapshot inicial
  React.useEffect(() => {
    if (!initialSnapshot) { setIsDirty(false); return; }
    const current = buildSnapshot(null, initialSnapshot.companyId);
    
    // comparação simples e robusta
    const clean = (o) => {
      // remove qualquer chave que comece com "_"
      const replacer = (key, value) => (key && key[0] === '_' ? undefined : value);
      return JSON.stringify(o, replacer);
    };

    const initialStr = clean(initialSnapshot);
    const currentStr = clean(current);

console.log('[initialStr]--------->]'+JSON.stringify(initialStr, null, 2));
console.log('[currentStr]--------->]'+JSON.stringify(currentStr, null, 2));

    setIsDirty(initialStr !== currentStr);
  }, [
    initialSnapshot,
    selectedCompany,
    nomeCompleto, cpf, nascimento, celular, pessoaGrupo,
    usuarioPerfil, email, editEmail,
    rightsCustom.manageAgencyUsers, rightsCustom.seeOwnReservationsOnly,
    wantPasswordNow, senha, 
    userStatus
  ]);  

  const validate = () => {
    const errors = [];

    if (selectCompany && !selectedCompany) errors.push('Selecione a agência.');

    if (!nomeCompleto?.trim()) errors.push('Informe o nome completo.');

    if (!cpf?.trim() || cpf.indexOf('_') !== -1 || !validarCPF(cpf)) {
      errors.push('Informe um CPF válido.');
    }

    if (!nascimento?.trim() || nascimento.indexOf('_') !== -1) {
      errors.push('Informe a data de nascimento.');
    } else if (!validarDataNascimentoMinima(nascimento)) {
      errors.push('Data de nascimento inválida ou fora do permitido.');
    }

    if (!celular?.trim() || !validarTelefone(celular)) {
      errors.push('Informe um celular válido.');
    }

    if (!pessoaGrupo) errors.push('Selecione o Grupo da Pessoa.');
    if (!usuarioPerfil) errors.push('Selecione o Perfil do Usuário.');

    if (![0,1,2].includes(userStatus)) {
      errors.push('Selecione o Status do usuário.');
    }    

    if (editEmail) {
      if (!validarEmail(email)) errors.push('Informe um e-mail válido.');
      if (email !== email2) errors.push('Os e-mails não conferem.');
    }    

    if (wantPasswordNow) {
      if (!senha || senha.length < 8) errors.push('Defina uma senha com pelo menos 8 caracteres.');
      if (senha !== senha2) errors.push('As senhas não conferem.');
    }

    return errors;
  };

 const handleSave = () => {
   const errors = validate();
   if (errors.length) {
     const body = <ul>{errors.map((e, i) => <li key={i}>{e}</li>)}</ul>;
     setAlert(true);
     setAlertTitle('Verifique as informações');
     setAlertBody(body);
     return;
   }

   confirmDialog({
     message: 'Confirmar a gravação das alterações deste usuário?',
     header: 'Confirmar alterações',
     icon: 'pi pi-question-circle',
     acceptLabel: 'Gravar',
     rejectLabel: 'Cancelar',
     acceptClassName: 'p-button-success',
     defaultFocus: 'reject',
     accept: async () => {
       try {
         setSaving(true);
         const payload = {
           userId,
           person: {
             fullName: nomeCompleto,
             cpf: cpf.replace(/\D/g, ''),
             birthDate: nascimento,
             phone: celular.replace(/\D/g, ''),
             group: pessoaGrupo
           },
           user: {
             profile: usuarioPerfil,
             ...(editEmail ? { email } : {}),
             ...(wantPasswordNow ? { password: senha } : {}),
             status: userStatus    
           },
           companyId: selectCompany ? selectedCompany : null,
           selectCompany,
           isMasterUser: isMasterUser ? 1 : 0,
           rights: {
             fromProfile: direitosDoPerfil,
             custom: {
               manageAgencyUsers: rightsCustom.manageAgencyUsers ? 1 : 0,
               seeOwnReservationsOnly: rightsCustom.seeOwnReservationsOnly ? 1 : 0
             }
           }
         };

         const resp = await updateUser(payload, {});
         if (resp?.success) {

          if (resp?.cpfAlreadyUsed) {
            setAlert(true);
            setAlertTitle('Ops! Ocorreu um problema!');
            setAlertBody('Já existe um usuário cadastrado com este CPF. Verifique as informações e tente novamente.');
            return;
          }

          if (resp?.emailAlreadyUsed) {
            setAlert(true);
            setAlertTitle('Ops! Ocorreu um problema!');
            setAlertBody('Já existe um usuário cadastrado com este e-mail. Verifique as informações e tente novamente.');
            return;
          }

           setAlert(true);
           setAlertTitle('Usuário atualizado');
           setAlertBody('As alterações foram salvas com sucesso. Caso o o usuário esteja logado, ele precisará fazer login novamente para que as alterações tenham efeito. Isso inclui o seu próprio usuário.');
           // “zera” o dirty se quiser manter aberto:
           // setInitialSnapshot(buildSnapshot(null, initialSnapshot?.companyId));
           resetAndClose();


         } else {
           setAlert(true);
           setAlertTitle('Erro');
           setAlertBody(resp?.errorMessage || 'Falha ao atualizar usuário.');
         }
       } catch (e) {
         setAlert(true);
         setAlertTitle('Erro');
         setAlertBody(e?.message || 'Falha ao atualizar usuário.');
       } finally {
         setSaving(false);
       }
     }
   });
 };

  const handleDelete_ = () => {
    if (!userId) return;
    confirmDialog({
      message: 'Tem certeza que deseja excluir este usuário? Esta ação não poderá ser desfeita.',
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptClassName: 'p-button-danger',
      defaultFocus: 'reject',
      accept: async () => {
        try {
          setSaving(true);
          const resp = await deleteUser({ userId }, {});<ConfirmDialog />
          if (resp?.success) {
            setAlert(true);
            setAlertTitle('Usuário excluído');
            setAlertBody('O usuário foi removido com sucesso. Caso ele estivesse logado, a sessão foi encerrada e ele precisará fazer login novamente para acessar o sistema.');
            resetAndClose();
          } else {
            setAlert(true);
            setAlertTitle('Erro');
            setAlertBody(resp?.errorMessage || 'Falha ao excluir usuário.');
          }
        } catch (e) {
          setAlert(true);
          setAlertTitle('Erro');
          setAlertBody(e?.message || 'Falha ao excluir usuário.');
        } finally {
          setSaving(false);
        }
      }
    });
  };

  const handleDelete = () => {
    if (!userId) return;

    confirmDialog({
      message: 'Tem certeza que deseja excluir este usuário? Esta ação não poderá ser desfeita.',
      header: 'Confirmar exclusão',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Excluir',
      rejectLabel: 'Cancelar',
      acceptClassName: 'p-button-danger',
      defaultFocus: 'reject',
      accept: async () => {
        try {
          setSaving(true);
          const resp = await deleteUser({ userId }, {});
          const fb = getDeleteUserFeedback(resp, null);

          if (fb.type === 'success') {
            setAlert(true);
            setAlertTitle(fb.title);
            setAlertBody(fb.body);
            resetAndClose();
          } else if (fb.type === 'warn') {
            setAlert(true);
            setAlertTitle(fb.title);
            setAlertBody(fb.body);
            // mesmo assim, atualiza lista e fecha
            resetAndClose();
          } else {
            setAlert(true);
            setAlertTitle(fb.title);
            setAlertBody(fb.body);
          }
        } catch (e) {
          const fb = getDeleteUserFeedback(null, e);
          setAlert(true);
          setAlertTitle(fb.title);
          setAlertBody(fb.body);
        } finally {
          setSaving(false);
        }
      }
    });
  };

  const headerTemplate = (
    <div className="flex-row align-items-center justify-start">
      <div className="flex-1">
        <h2 className="m-0" style={{fontSize:"1.2rem",margin:0}}>
          Editar usuário {isMasterUser ? '(Agência Master)' : ''} {CompanyPersonName ? ` - ${CompanyPersonName}` : ''}
        </h2>
      </div>
    </div>
  );

  const footerContent = (
    <div className="modalFooterButtons" style={{}}>
      <div className="modalFooterButtonsLeft" style={{height:"50px"}}>
        {userRights?.includes('manageUsers') && (
          <span id="deleteBtnWrapper" className="tooltip" data-pr-tooltip={isMaster ? 'Usuário Master não pode ser excluído' : ''}>
            <Button label="Excluir" icon="pi pi-trash" className="p-button-danger p-button-text" disabled={saving || isMaster} onClick={handleDelete} />
          </span>
        )}
      </div>
      <div className="modalFooterButtonsRight">
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text" disabled={saving} onClick={resetAndClose} />
        <span
          id="saveBtnWrapper"
          {...(!isDirty ? { 'data-pr-tooltip': 'Nenhuma alteração realizada' } : {})}
        >
          <Button
            label={saving ? 'Gravando...' : 'Gravar alterações'}
            icon={saving ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
            onClick={handleSave}
            disabled={saving || !isDirty || loadingForm}
          />
        </span>        
      </div>
    </div>
  );

  return (
    <Dialog
      header={headerTemplate}
      visible={isOpen}
      style={{ width: '75vw', height: '90vh' }}
      breakpoints={{ '1360px': '95vw','960px': '90vw','641px': '100vw' }}
      onHide={resetAndClose}
      footer={footerContent}
      maximizable={!saving}
      closable={!saving}
      closeOnEscape
      key="user-edit-modal"
    >
      <Box sx={{ width: "100%" }}>

        {/* LOADING  */}
        {loadingForm &&
          <>
            <div style={{backgroundColor:"transparent", width:"100%",maxWidth:"1170px", marginTop:"30px",marginBottom:"50px",display:"flex",alignItems:"center",justifyContent:"flex-start",flexDirection:"row"}}>
            
                <ProgressSpinner style={{width: '40px', height: '40px',marginRight: "20px",marginLeft:"20px"}} strokeWidth="4" />
                <div style={{fontSize:"16px",marginTop:"0px"}}> Buscando dados do usuário... </div>
                                        
            </div>
            
            <Skeleton width="100%" height="4rem" ></Skeleton>
            <br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
            <br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
            <br />
            <Skeleton width="100%" height="4rem" ></Skeleton>
            
          </>				
        }
        
        {/* CONTENT  */}
        {!loadingForm &&
        <>
        <div className="navigationContentWrapper flex-row justify-center align-items-start" style={{marginTop:"1rem", width:"100%", gap:"1rem"}}>

          {/* Coluna Esquerda: Formulário */}
          <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem", flex:1.1}}>
            <div className="resultsCard flex-column justify-center align-items-stretch w100" style={{gap:"1.5rem", padding:"2rem", borderRadius:"1.87rem", background:"#FFF"}}>

              {/* BLOCO 0 – Seleção de agência (mesmo da Create) */}
              {selectCompany &&
              <>
                <div style={{fontWeight:600, fontSize:"1rem"}}>Selecione a agência</div>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <div className="field">
                      <label>Agência <span className="requiredField">*</span></label>
                      <Dropdown
                        value={selectedCompany}
                        onChange={(e) => setSelectedCompany(e.value)}
                        options={agenciasOptions}
                        optionLabel="label"
                        optionValue="value"
                        placeholder={loadingAgencias ? 'Carregando...' : 'Selecione a agência'}
                        className="w100"
                        disabled={loadingAgencias}
                        itemTemplate={(option) => (
                          <>
                            <div>
                              <div>{option.label}</div>
                              <small style={{color:'#555'}}>{option.subLabel}</small>
                            </div>
                          </>
                        )}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={6}></Grid>
                </Grid>
              </>
              }

              {/* BLOCO 1 – Dados da Pessoa */}
              <div style={{fontWeight:600, fontSize:"1rem"}}>Dados da Pessoa</div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={8}>
                  <div className="field">
                    <label>Nome completo <span className="requiredField">*</span></label>
                    <InputText value={nomeCompleto} onChange={(e)=>setNomeCompleto(e.target.value)} className="w100" placeholder="Nome e sobrenome" />
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="field">
                    <label>CPF <span className="requiredField">*</span></label>
                    <InputMask mask="999.999.999-99" value={cpf} onChange={(e)=>setCpf(e.value)} className="w100" placeholder="000.000.000-00" />
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="field">
                    <label>Data de Nascimento <span className="requiredField">*</span></label>
                    <InputMask mask="99/99/9999" value={nascimento} onChange={(e)=>setNascimento(e.value)} className="w100" placeholder="dd/mm/aaaa" />
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="field">
                    <label>Telefone Celular <span className="requiredField">*</span></label>
                    <InputText value={celular} onChange={(e)=>setCelular(maskPhone(e.target.value))} className="w100" placeholder="(00) 00000-0000" />
                  </div>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <div className="field">
                    <label>Grupo <span className="requiredField">*</span></label>
                    <Dropdown
                      value={pessoaGrupo}
                      onChange={(e) => setPessoaGrupo(e.value)}
                      options={pessoaGruposOptions}
                      optionLabel="label"
                      optionValue="value"
                      placeholder={loadingPessoaGrupos ? 'Carregando...' : 'Selecione o grupo'}
                      className="w100"
                      disabled={loadingPessoaGrupos}
                    />
                  </div>
                </Grid>
              </Grid>

              {/* BLOCO 2 – Dados do Usuário */}
              <div style={{fontWeight:600, fontSize:"1rem", marginTop:"0.5rem"}}>Dados do Usuário</div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <div className="field">
                    <label>Setor (Perfil) <span className="requiredField">*</span></label>
                    <Dropdown
                      value={usuarioPerfil}
                      onChange={(e) => setUsuarioPerfil(e.value)}
                      options={usuarioPerfisOptions}
                      optionLabel="label"
                      optionValue="value"
                      placeholder={loadingUsuarioPerfis ? 'Carregando...' : 'Selecione o perfil'}
                      className="w100"
                      disabled={loadingUsuarioPerfis}
                    />
                    {loadingRights && (
                      <div style={{marginTop:8, display:'flex', alignItems:'center', gap:8}}>
                        <ProgressSpinner style={{width: '20px', height: '20px'}} strokeWidth="4" />
                        <small>Carregando direitos do perfil…</small>
                      </div>
                    )}
                  </div>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <div className="field">
                    <label>Status <span className="requiredField">*</span></label>
                    <Dropdown
                      value={userStatus}
                      onChange={(e) => setUserStatus(e.value)}
                      options={STATUS_OPTIONS}
                      optionLabel="label"
                      optionValue="value"
                      className="w100"
                      placeholder="Selecione o status"
                    />
                  </div>
                </Grid>

                <Grid item xs={12} sm={12}>
                  <div className="field">
                    <div className="flex-row" style={{ alignItems:'center', gap:10 }}>
                      <Checkbox
                        inputId="editEmail"
                        checked={editEmail}
                        onChange={(e)=> {
                          setEditEmail(e.checked);
                          if (e.checked) {
                            // Ativou edição de e-mail: começar com campos vazios
                            setEmail('');
                            setEmail2('');
                          } else {
                            // Desativou: restaurar valor original do snapshot
                            const originalEmail = initialSnapshot?.user?.email ?? '';
                            setEmail(originalEmail);
                            setEmail2(originalEmail);
                          }
                        }}
                      />
                      <label htmlFor="editEmail">Alterar o e-mail de login</label>
                    </div>
                  </div>
                </Grid>

                {!editEmail && (
                  <Grid item xs={12} sm={6}>
                    <div className="field">
                      <label>Email de login</label>
                      <InputText value={email} className="w100" disabled />
                    </div>
                  </Grid>
                )}

                {editEmail && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <div className="field">
                        <label>Novo e-mail de login <span className="requiredField">*</span></label>
                        <InputText value={email} onChange={(e)=>setEmail(e.target.value)} className="w100" placeholder="nome@empresa.com" key="edit-email" />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div className="field">
                        <label>Confirme o novo e-mail <span className="requiredField">*</span></label>
                        <InputText inputProps={{ autoComplete: 'off' }} autoComplete="off" id="emailConfirmation" value={email2} onChange={(e)=>setEmail2(e.target.value)} className="w100" placeholder="repita o e-mail" key="edit-email2" />
                      </div>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={12}>
                  <Checkbox
                    inputId="wantPasswordNow"
                    checked={wantPasswordNow}
                    onChange={(e) => {
                      setWantPasswordNow(e.checked);
                      if (!e.checked) {
                        setSenha(''); setSenha2('');
                      }
                      // sempre limpa os campos ao alternar (ativa ou desativa)
                      setSenha('');
                      setSenha2('');                      
                    }}
                  />
                  <label htmlFor="wantPasswordNow" style={{ marginLeft: 8 }}>
                    Definir nova senha para o usuário agora
                  </label>
                </Grid>

                {wantPasswordNow && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <div className="field">
                        <label>Nova senha <span className="requiredField">*</span></label>
                        <Password
                          value={senha}
                          onChange={(e) => setSenha(e.target.value)}
                          toggleMask
                          feedback
                          placeholder="mín. 8 caracteres"
                          autoComplete="new-password"
                          className="w100"
                          maxLength={20}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div className="field">
                        <label>Confirmação de senha <span className="requiredField">*</span></label>
                        <Password
                          id="passwordConfirmation"
                          value={senha2}
                          onChange={(e)=>setSenha2(e.target.value)}
                          className="w100"
                          toggleMask
                          feedback={false}
                          placeholder="repita a senha"
                        />
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>

              {/* BLOCO 3 – Direitos individuais */}
              <div style={{fontWeight:600, fontSize:"1rem", marginTop:"0.5rem"}}>Direitos e restrições especiais</div>
              <Grid container spacing={2}>
                {userRights.includes('manageUsers') && (
                  <Grid item xs={12} sm={12}>
                    <div className="flex-row" style={{gap:"10px", alignItems:'center'}}>
                        <Checkbox
                          inputId="manageAgencyUsers"
                          checked={rightsCustom.manageAgencyUsers}
                          disabled={isMaster}
                          onChange={(e)=>setRightsCustom(v=>({...v, manageAgencyUsers: e.checked}))}
                        />
                        <label htmlFor="manageAgencyUsers">Gerenciar usuários da agência</label>
                        {isMaster && <small>(Usuário master não pode retirar esse direito)</small>}
                    </div>
                  </Grid>
                )}
                <Grid item xs={12} sm={12}>
                  <div className="flex-row" style={{gap:"10px", alignItems:'center'}}>
                    <Checkbox
                      inputId="seeOwnReservationsOnly"
                      checked={rightsCustom.seeOwnReservationsOnly}
                      onChange={(e)=>setRightsCustom(v=>({...v, seeOwnReservationsOnly: e.checked}))}
                    />
                    <label htmlFor="seeOwnReservationsOnly">Visualizar apenas as próprias reservas</label>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>

          {/* Coluna Direita: Direitos do grupo/perfil selecionado (idêntica à Create) */}
          <div className="resultsWrapper flex-column justify-center align-items-center" style={{gap:"1rem", flex:0.6, alignSelf:'stretch',justifyContent:'flex-start'}}>
            <div className="resultsCard flex-column justify-start align-items-stretch w100" style={{gap:"0.75rem", padding:"1.5rem", borderRadius:"1.87rem", background:"#FFF",position:'sticky',top:'10px'}}>
              <div style={{fontWeight:600, fontSize:"1rem"}}>Direitos do grupo / perfil do usuário</div>
              {!usuarioPerfil && <small style={{color:"#777"}}>Selecione um grupo / perfil (Gestão, Administrativo, Operacional ou Comercial) para visualizar os direitos vinculados.</small>}
              {usuarioPerfil && !loadingRights && (
                <ul style={{margin:0, paddingLeft:'1.1rem'}}>
                  {Array.isArray(direitosDoPerfil) && direitosDoPerfil.length > 0 ? direitosDoPerfil.map((d,i)=>(
                    <li key={i} style={{lineHeight:'1.6rem'}}>{typeof d === 'string' ? d : (d?.label || 'Direito')}</li>
                  )) : <small style={{color:"#777"}}>Nenhum direito retornado para este perfil.</small>}
                </ul>
              )}
            </div>
          </div>

        </div>
        </>
        }

      </Box>

      <ConfirmDialog />
      <Tooltip target="#saveBtnWrapper" position='top' />
      <Tooltip target="#deleteBtnWrapper" position='top' />
      <Tooltip target="#checkboxBtnWrapper" position='top' />
      <Toast ref={toast} position="bottom-center" />
    </Dialog>
  );
};

const mapStateToProps = (store) => ({
  dialog: store.appReducer.dialog,
  masterUser: store.appReducer.masterUser,
  userRights: store.appReducer.userRights
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions, ...UserActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserEditModal);
